import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from "@ngx-translate/core";

import { MatOptionModule } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";
import { BlacklistedUsersComponent } from './blacklisted-users/blacklisted-users.component';
import { ConfirmRemoveBlacklistedDialogComponent } from './dialogs/confirm-remove-blacklisted-dialog/confirm-remove-blacklisted-dialog.component';
import { FilterUsersDialogComponent } from './dialogs/filter-users-dialog/filter-users-dialog.component';
import { SaveUserHeaderComponent } from "./save-user-header/save-user-header.component";
import { SaveUserComponent } from "./save-user/save-user.component";
import { UserDataInputComponent } from "./user-data-input/user-data-input.component";
import { UserDataInputModule } from './user-data-input/user-data-input.module';
import {
    DialogOverviewExampleDialog,
    UserListComponent,
} from "./user-list/user-list.component";


@NgModule({
  imports: [
    SharedModule,
    MatDialogModule,
    MatTabsModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatDatepickerModule,
    MatDividerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatChipsModule,
    TranslateModule,
    MatTooltipModule,
    MatOptionModule,
    MatSelectModule,
    MatSlideToggleModule,
    RouterModule,
    UserDataInputModule,
  ],
  declarations: [
    UserListComponent,
    DialogOverviewExampleDialog,
    SaveUserComponent,
    UserDataInputComponent,
    SaveUserHeaderComponent,
    FilterUsersDialogComponent,
    BlacklistedUsersComponent,
    ConfirmRemoveBlacklistedDialogComponent,
  ],
  exports: [UserListComponent],
  entryComponents: [DialogOverviewExampleDialog],
})
export class UsersModule {}
